export type Language = "EN" | "ES" | "FR";

export type RegistrationFormData = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  address: string;
  city: string;
  zipCode: string;
  privacyConsent: boolean;
  contactConsent: boolean;
  preferredLanguage: Language;
};

export function createInitialRegistration(language: Language = "EN"): RegistrationFormData {
  return {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
    privacyConsent: false,
    contactConsent: false,
    preferredLanguage: language,
  };
}

export function isValidEmail(value: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function isValidPhone(value: string) {
  return value.replace(/\D/g, "").length >= 10;
}

export function isValidZipCode(value: string) {
  return /^\d{5}(?:-\d{4})?$/.test(value.trim());
}
